import type { AppConfig } from '@ms-cloudpack/common-types';
import fs from 'fs';
import { getConfigPath } from '../getConfigPath.js';
import { writeAppConfig } from './writeAppConfig.js';

const configTemplate: AppConfig = {
  packageSettings: [
    {
      match: {
        name: 'package-name',
        version: '*',
      },

      exports: {
        '.': './index.js',
        './path': './path.js',
        './other-path': './other-path.js',
      },

      inlinedDependencies: [],

      includedDependencies: [],
      excludedDependencies: [],

      bundler: undefined,
    },
  ],
};

/**
 * If no `cloudpack.config.json` exists at `appPath`, create one with some demo settings.
 * @returns Path to the config file.
 */
export async function ensureAppConfig(appPath: string): Promise<string> {
  const { defaultAppConfigPath, appConfigPaths } = getConfigPath(appPath);
  let configPath = appConfigPaths.find((path) => fs.existsSync(path)) || defaultAppConfigPath;
  if (!configPath) {
    // If no config file exists, write the default one.
    await writeAppConfig(configTemplate, appPath);
    configPath = defaultAppConfigPath;
  }
  return configPath;
}
